import styles from "../ProductStatusBox.module.scss";
import { UnderlinedButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import { ProductType } from "../../../types/types";

export type ProductStatusProps = {
  title: string;
  price: string;
  statusMessage: string;
  handleDescriptionCTA: () => void;
  productType?: ProductType;
};

export const ProductStatus = ({
  productType,
  statusMessage,
  price,
  title,
  handleDescriptionCTA,
}: ProductStatusProps) => {
  return (
    <div className={styles.info}>
      <h1 className={styles.title}>{title}</h1>
      {price && <p className={styles.price}>{price}</p>}
      <p className={styles.statusMessage}>{statusMessage}</p>
      {productType !== "RetiredStaticBundle" ? (
        <UnderlinedButton
          className={styles.statusLink}
          data-testid="skiplinks:top-box-description"
          onClick={handleDescriptionCTA}
        >
          View product description
        </UnderlinedButton>
      ) : (
        <UnderlinedButton
          tag="a"
          className={styles.statusLink}
          data-testid="skiplinks:top-box-howToReturn"
          href="/customer-services/returns/how-do-i-return-an-item"
        >
          How to return an item
        </UnderlinedButton>
      )}
    </div>
  );
};
